
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code6 } from "@/views/resources/documentation/element-ui/basic/layout/code";

export default defineComponent({
  name: "responsive-layout",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code6
    };
  }
});
